import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from 'recharts';
import ChartGlassPanel from '../../components/ChartGlassPanel';

const data = [
  { month: 'Feb', payroll: 100000 },
  { month: 'Mar', payroll: 105000 },
  { month: 'Apr', payroll: 110000 },
  { month: 'May', payroll: 115000 },
  { month: 'Jun', payroll: 118000 },
  { month: 'Jul', payroll: 120000 },
];

export default function PayrollLineChart() {
  return (
    <ChartGlassPanel>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="payroll" stroke="#2563eb" strokeWidth={3} dot={{ r: 5 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </ChartGlassPanel>
  );
}
